import { useRouter } from '@townsquare/router/useRouter';
import { ForYouConfig } from '@atlassian/global-side-navigation';
import { useMemo } from 'react';

import { AnalyticsSideNavItem, useSendSideNavItemClick } from '@townsquare/analytics-nav4';
import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { generatePath } from '@townsquare/router/primitives/path';
import { useQueryParams } from '@townsquare/router/use-query-params';
import { homeTabRoute } from '@townsquare/routes/hometab-view';

export const useForYouConfig = () => {
	const routeDependencies = useRouteDependencies();
	const [routerStore, routerActions] = useRouter();
	const sendSideNavItemClick = useSendSideNavItemClick();
	const screenQueryParam = useQueryParams()['screen'];

	return useMemo<ForYouConfig>(() => {
		const newUrl = generatePath(homeTabRoute, routeDependencies);
		const newConfig: ForYouConfig = {
			forYouItem: {
				url: newUrl,
				isSelected:
					screenQueryParam === undefined &&
					Boolean(matchRoute([homeTabRoute], routerStore.location.pathname, undefined)),
				onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
					event.preventDefault();
					routerActions.push(newUrl);
					sendSideNavItemClick('navigationItem', AnalyticsSideNavItem.HOME, { screen: routerStore.route.name });
				},
			},
		};
		return newConfig;
	}, [
		routerStore.location.pathname,
		routeDependencies,
		routerActions,
		routerStore.route.name,
		screenQueryParam,
		sendSideNavItemClick,
	]);
};
